import React, { Fragment, ReactElement } from 'react';
import { View, ViewProps } from 'react-native';
import { isElement } from 'react-is';
import { useDerivedValue } from '@pulsar/core';
import { isMobile } from 'src/utils/platform';
import { PlatformPadding } from 'src/components/PlatformPadding';
import useStyles from './Group.styles';

export type GroupProps = ViewProps & {
  header?: ReactElement;
  separator?: boolean | ReactElement;
};

export const Group: React.FC<GroupProps> = ({
  children,
  header,
  separator = true,
  style,
  ...props
}) => {
  const s = useStyles();
  const showPadding = useDerivedValue(isMobile);

  return (
    <Fragment>
      <View style={[s.root, style]} {...props}>
        {header}
        {children}
      </View>
      {separator &&
        (isElement(separator) ? (
          separator
        ) : (
          <PlatformPadding horizontal={showPadding}>
            <View>
              <View style={s.separator} />
            </View>
          </PlatformPadding>
        ))}
    </Fragment>
  );
};
